// extracted by mini-css-extract-plugin
export default {"form":"ak","inline":"bk","inputWrapper":"ck","input":"dk","withoutLabel":"ek","error":"fk","label":"gk"};